(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-blog-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('os-reveal');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold:0.08});
    scope.querySelectorAll('.os-blog-hub[data-motion="true"] .os-blog-card').forEach(card => observer.observe(card));
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {

  function OSReviews(rootElement) {

    this.root = rootElement;

    this.judgeme =
      rootElement.querySelector(
        '[data-os-judgeme]'
      );

    this.summary =
      rootElement.querySelector(
        '[data-os-summary]'
      );

    this.average =
      rootElement.querySelector(
        '[data-os-average]'
      );

    this.summaryStars =
      rootElement.querySelector(
        '[data-os-summary-stars]'
      );

    this.count =
      rootElement.querySelector(
        '[data-os-count]'
      );

    this.carousel =
      rootElement.querySelector(
        '[data-os-carousel]'
      );

    this.viewport =
      rootElement.querySelector(
        '[data-os-viewport]'
      );

    this.track =
      rootElement.querySelector(
        '[data-os-track]'
      );

    this.controls =
      rootElement.querySelector(
        '[data-os-controls]'
      );

    this.prev =
      rootElement.querySelector(
        '[data-os-prev]'
      );

    this.next =
      rootElement.querySelector(
        '[data-os-next]'
      );

    this.dots =
      rootElement.querySelector(
        '[data-os-dots]'
      );

    this.empty =
      rootElement.querySelector(
        '[data-os-empty]'
      );


    this.sourceReviews = [];

    this.pages = [];

    this.page = 0;

    this.perPage =
      this.getPerPage();

    this.pageCount = 0;

    this.offset = 0;

    this.lastSignature = '';

    this.destroyed = false;

    this.dragging = false;

    this.hasDragged = false;

    this.startX = 0;

    this.startY = 0;

    this.queuedHydrate = null;

    this.heightFrame = null;


    this.reduceMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );


    this.boundResize =
      this.onResize.bind(this);

    this.boundPointerDown =
      this.onPointerDown.bind(this);

    this.boundPointerMove =
      this.onPointerMove.bind(this);

    this.boundPointerUp =
      this.onPointerUp.bind(this);

    this.boundHydrate =
      this.scheduleHydrate.bind(this);


    this.init();

  }


  /* =========================================================
     INIT
     ========================================================= */

  OSReviews.prototype.init = function () {

    var self = this;


    if (
      !this.judgeme ||
      !this.viewport ||
      !this.track
    ) {

      return;

    }


    if (this.prev) {

      this.prev.addEventListener(
        'click',
        function () {

          self.goTo(
            self.page - 1
          );

        }
      );

    }


    if (this.next) {

      this.next.addEventListener(
        'click',
        function () {

          self.goTo(
            self.page + 1
          );

        }
      );

    }


    this.viewport.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'ArrowLeft') {

          event.preventDefault();

          self.goTo(
            self.page - 1
          );

        }


        if (event.key === 'ArrowRight') {

          event.preventDefault();

          self.goTo(
            self.page + 1
          );

        }

      }
    );


    this.viewport.addEventListener(
      'pointerdown',
      this.boundPointerDown
    );

    this.viewport.addEventListener(
      'pointermove',
      this.boundPointerMove
    );

    this.viewport.addEventListener(
      'pointerup',
      this.boundPointerUp
    );

    this.viewport.addEventListener(
      'pointercancel',
      this.boundPointerUp
    );


    window.addEventListener(
      'resize',
      this.boundResize
    );


    this.observer =
      new MutationObserver(
        this.boundHydrate
      );


    this.observer.observe(
      this.judgeme,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );


    this.scheduleHydrate();


    this.retry =
      window.setInterval(
        function () {

          self.hydrate();


          if (
            self.sourceReviews.length ||
            self.destroyed
          ) {

            window.clearInterval(
              self.retry
            );

            self.retry = null;

          }

        },
        400
      );


    this.retryEnd =
      window.setTimeout(
        function () {

          if (self.retry) {

            window.clearInterval(
              self.retry
            );

            self.retry = null;

          }

        },
        8000
      );

  };


  /* =========================================================
     DESTROY
     ========================================================= */

  OSReviews.prototype.destroy = function () {

    this.destroyed = true;


    if (this.observer) {

      this.observer.disconnect();

    }


    if (this.retry) {

      window.clearInterval(
        this.retry
      );

    }


    if (this.retryEnd) {

      window.clearTimeout(
        this.retryEnd
      );

    }


    if (this.queuedHydrate) {

      window.cancelAnimationFrame(
        this.queuedHydrate
      );

    }


    if (this.heightFrame) {

      window.cancelAnimationFrame(
        this.heightFrame
      );

    }


    window.removeEventListener(
      'resize',
      this.boundResize
    );


    if (this.viewport) {

      this.viewport.removeEventListener(
        'pointerdown',
        this.boundPointerDown
      );

      this.viewport.removeEventListener(
        'pointermove',
        this.boundPointerMove
      );

      this.viewport.removeEventListener(
        'pointerup',
        this.boundPointerUp
      );

      this.viewport.removeEventListener(
        'pointercancel',
        this.boundPointerUp
      );

    }

  };


  /* =========================================================
     HYDRATE
     ========================================================= */

  OSReviews.prototype.scheduleHydrate = function () {

    var self = this;


    if (
      this.destroyed ||
      this.queuedHydrate
    ) {

      return;

    }


    this.queuedHydrate =
      window.requestAnimationFrame(
        function () {

          self.queuedHydrate = null;

          self.hydrate();

        }
      );

  };


  OSReviews.prototype.hydrate = function () {

    var widget =
      this.getWidget();


    if (!widget) {
      if (this.empty) {
        this.empty.textContent = 'Anmeldelsene kunne ikke lastes.';
        this.empty.hidden = false;
      }
      return;
    }


    this.renderSummary(
      widget
    );


    this.collectReviews(
      widget
    );


    this.update();

  };


  OSReviews.prototype.getWidget = function () {

    if (!this.judgeme) {

      return null;

    }


    var template = this.judgeme.querySelector('[data-os-review-source]');
    var source = template ? template.content : this.judgeme;
    return source.querySelector('.jdgm-rev-widg') || source.querySelector('.jdgm-widget');

  };


  /* =========================================================
     SUMMARY
     ========================================================= */

  OSReviews.prototype.renderSummary = function (
    widget
  ) {

    if (
      !this.summary ||
      !this.average ||
      !this.summaryStars ||
      !this.count
    ) {

      return;

    }


    var average =
      this.readAverage(
        widget
      );


    var count =
      this.readCount(
        widget
      );


    if (average !== null) {

      this.average.textContent =
        average.toLocaleString(
          'nb-NO',
          {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
          }
        ) +
        ' av 5';


      this.renderStars(
        this.summaryStars,
        average
      );

    } else {

      this.average.textContent =
        'Anmeldelser';


      this.summaryStars.replaceChildren();

    }


    if (count === 1) {

      this.count.textContent =
        'Basert på 1 anmeldelse';

    } else if (count > 1) {

      this.count.textContent =
        'Basert på ' +
        count +
        ' anmeldelser';

    } else {

      this.count.textContent =
        'Basert på kundeanmeldelser';

    }


    this.summary.hidden = false;

  };


  /* =========================================================
     STARS
     ========================================================= */

  OSReviews.prototype.renderStars = function (
    target,
    rating
  ) {

    if (!target) {

      return;

    }


    target.replaceChildren();


    var wrapper =
      document.createElement(
        'span'
      );


    wrapper.className =
      'os-stars';


    for (
      var index = 0;
      index < 5;
      index += 1
    ) {

      var fill =
        Math.max(
          0,
          Math.min(
            1,
            rating - index
          )
        );


      var star =
        document.createElement(
          'span'
        );


      star.className =
        'os-star';


      star.textContent =
        '★';


      star.style.setProperty(
        '--os-fill',
        (fill * 100) + '%'
      );


      wrapper.appendChild(
        star
      );

    }


    target.appendChild(
      wrapper
    );

  };


  /* =========================================================
     COLLECT REVIEWS
     ========================================================= */

  OSReviews.prototype.collectReviews = function (
    widget
  ) {

    var source =
      widget.querySelector(
        '.jdgm-rev-widg__reviews'
      ) ||
      widget;


    var reviews =
      Array.prototype.slice.call(
        source.querySelectorAll(
          '.jdgm-rev'
        )
      );


    var signature =
      reviews
        .map(
          function (review) {

            return (
              review.getAttribute(
                'data-review-id'
              ) ||
              review.textContent
                .replace(/\s+/g, ' ')
                .trim()
                .slice(0, 250)
            );

          }
        )
        .join('|');


    if (
      signature &&
      signature === this.lastSignature &&
      this.sourceReviews.length
    ) {

      return;

    }


    this.lastSignature =
      signature;


    this.sourceReviews =
      reviews;


    this.page = 0;


    this.buildPages();

  };


  /* =========================================================
     BUILD PAGES
     ========================================================= */

  OSReviews.prototype.buildPages = function () {

    this.track.replaceChildren();


    this.perPage =
      this.getPerPage();


    this.pages = [];


    if (!this.sourceReviews.length) {

      this.carousel.hidden = true;

      this.empty.hidden = false;

      return;

    }


    for (
      var index = 0;
      index < this.sourceReviews.length;
      index += this.perPage
    ) {

      var page =
        document.createElement(
          'div'
        );


      page.className =
        'os-reviews-page';


      for (
        var inner = 0;
        inner < this.perPage;
        inner += 1
      ) {

        var reviewIndex =
          index + inner;


        if (
          reviewIndex >=
          this.sourceReviews.length
        ) {

          break;

        }


        var card =
          this.buildReview(
            this.sourceReviews[
              reviewIndex
            ]
          );


        page.appendChild(
          card
        );

      }


      this.track.appendChild(
        page
      );


      this.pages.push(
        page
      );

    }


    this.pageCount =
      this.pages.length;


    this.carousel.hidden = false;

    this.empty.hidden = true;

  };


  /* =========================================================
     BUILD ONE REVIEW
     ========================================================= */

  OSReviews.prototype.buildReview = function (
    sourceReview
  ) {

    var card =
      document.createElement(
        'article'
      );


    card.className =
      'os-review';


    var ratingNode =
      sourceReview.querySelector(
        '.jdgm-rev__rating'
      );


    var timestampNode =
      sourceReview.querySelector(
        '.jdgm-rev__timestamp, .jdgm-rev__date, time'
      );


    var timestampValue =
      '';


    if (timestampNode) {

      timestampValue =
        timestampNode.getAttribute(
          'datetime'
        ) ||
        timestampNode.getAttribute(
          'data-content'
        ) ||
        timestampNode.textContent ||
        '';

    }


    var authorNode =
      sourceReview.querySelector(
        '.jdgm-rev__author'
      );


    var titleNode =
      sourceReview.querySelector(
        '.jdgm-rev__title'
      );


    var bodyNode =
      sourceReview.querySelector(
        '.jdgm-rev__body'
      );


    var verifiedNode =
      sourceReview.querySelector(
        '.jdgm-rev__buyer-badge, .jdgm-verified-badge'
      );


    var mediaNode =
      sourceReview.querySelector(
        '.jdgm-rev__pics, .jdgm-rev__photos'
      );


    var replyNode =
      sourceReview.querySelector(
        '.jdgm-rev__reply'
      ) ||
      sourceReview.querySelector(
        '.jdgm-rev__reply-content'
      );


    var rating =
      this.readReviewRating(
        ratingNode
      );


    var author =
      authorNode
        ? authorNode.textContent.trim()
        : 'Anonym';


    if (!author) {

      author = 'Anonym';

    }


    /* =====================================================
       TOP
       ===================================================== */

    var top =
      document.createElement(
        'div'
      );


    top.className =
      'os-review__top';


    var stars =
      document.createElement(
        'div'
      );


    stars.className =
      'os-review__stars';


    if (rating !== null) {

      this.renderStars(
        stars,
        rating
      );

    }


    top.appendChild(
      stars
    );


    if (timestampValue.trim()) {

      var formattedDate =
        this.formatDate(
          timestampValue.trim()
        );


      if (formattedDate) {

        var date =
          document.createElement(
            'p'
          );


        date.className =
          'os-review__date';


        date.textContent =
          formattedDate;


        top.appendChild(
          date
        );

      }

    }


    card.appendChild(
      top
    );


    /* =====================================================
       AUTHOR
       ===================================================== */

    var authorRow =
      document.createElement(
        'div'
      );


    authorRow.className =
      'os-review__author-row';


    var authorElement =
      document.createElement(
        'p'
      );


    authorElement.className =
      'os-review__author';


    authorElement.textContent =
      author;


    authorRow.appendChild(
      authorElement
    );


    if (verifiedNode) {

      var verified =
        document.createElement(
          'span'
        );


      verified.className =
        'os-review__verified';


      verified.textContent =
        'Verifisert';


      authorRow.appendChild(
        verified
      );

    }


    card.appendChild(
      authorRow
    );


    /* =====================================================
       TITLE
       ===================================================== */

    if (
      titleNode &&
      titleNode.textContent.trim()
    ) {

      var title =
        document.createElement(
          'p'
        );


      title.className =
        'os-review__title';


      title.textContent =
        titleNode.textContent.trim();


      card.appendChild(
        title
      );

    }


    /* =====================================================
       BODY
       ===================================================== */

    if (
      bodyNode &&
      bodyNode.textContent.trim()
    ) {

      var body =
        document.createElement(
          'div'
        );


      body.className =
        'os-review__body';


      body.innerHTML =
        bodyNode.innerHTML;


      card.appendChild(
        body
      );

    }


    /* =====================================================
       MEDIA
       ===================================================== */

    if (
      mediaNode &&
      mediaNode.querySelector(
        'img'
      )
    ) {

      var media =
        document.createElement(
          'div'
        );


      media.className =
        'os-review__media';


      Array.prototype.slice.call(
        mediaNode.querySelectorAll(
          'img'
        )
      ).forEach(
        function (image) {

          media.appendChild(
            image.cloneNode(true)
          );

        }
      );


      card.appendChild(
        media
      );

    }


    /* =====================================================
       STORE REPLY
       ===================================================== */

    var replyData =
      this.extractReply(
        replyNode
      );


    if (replyData.hasContent) {

      var reply =
        document.createElement(
          'div'
        );


      reply.className =
        'os-review__reply';


      var replyTitle =
        document.createElement(
          'strong'
        );


      replyTitle.className =
        'os-review__reply-title';


      replyTitle.textContent =
        'Østfold Smakskompani svarer:';


      reply.appendChild(
        replyTitle
      );


      var replyBody =
        document.createElement(
          'div'
        );


      replyBody.className =
        'os-review__reply-body';


      replyBody.innerHTML =
        replyData.html;


      reply.appendChild(
        replyBody
      );


      card.appendChild(
        reply
      );

    }


    return card;

  };


  /* =========================================================
     EXTRACT REAL REPLY
     ========================================================= */

  OSReviews.prototype.extractReply = function (
    replyNode
  ) {

    if (!replyNode) {

      return {
        hasContent: false,
        html: ''
      };

    }


    var clone =
      replyNode.cloneNode(
        true
      );


    var metadataSelectors = [
      '.jdgm-rev__reply-title',
      '.jdgm-rev__reply-author',
      '.jdgm-rev__reply-timestamp',
      '.jdgm-rev__reply-label',
      '.jdgm-rev__timestamp',
      '.jdgm-rev__date'
    ];


    metadataSelectors.forEach(
      function (selector) {

        Array.prototype.slice.call(
          clone.querySelectorAll(
            selector
          )
        ).forEach(
          function (node) {

            node.remove();

          }
        );

      }
    );


    Array.prototype.slice.call(
      clone.querySelectorAll('*')
    )
      .reverse()
      .forEach(
        function (node) {

          var text =
            node.textContent
              .replace(/\u00a0/g, ' ')
              .replace(/\s+/g, ' ')
              .trim();


          var hasMedia =
            node.querySelector(
              'img, video'
            );


          if (
            !text &&
            !hasMedia
          ) {

            node.remove();

          }

        }
      );


    var plainText =
      clone.textContent
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();


    var meaningfulText =
      plainText
        .replace(
          /Østfold Smakskompani svarer:?/gi,
          ''
        )
        .replace(
          /store owner replied:?/gi,
          ''
        )
        .replace(
          /reply from store:?/gi,
          ''
        )
        .replace(
          /shop owner replied:?/gi,
          ''
        )
        .trim();


    if (!meaningfulText) {

      return {
        hasContent: false,
        html: ''
      };

    }


    return {
      hasContent: true,
      html: clone.innerHTML
    };

  };


  /* =========================================================
     AVERAGE
     ========================================================= */

  OSReviews.prototype.readAverage = function (
    widget
  ) {

    var source =
      widget.getAttribute(
        'data-average-rating'
      );


    var averageNode =
      widget.querySelector(
        '.jdgm-rev-widg__summary-average'
      );


    var starsNode =
      widget.querySelector(
        '.jdgm-rev-widg__summary-stars'
      );


    if (
      !source &&
      averageNode
    ) {

      source =
        averageNode.textContent;

    }


    if (
      !source &&
      starsNode
    ) {

      source =
        starsNode.getAttribute(
          'aria-label'
        );

    }


    return this.parseNumber(
      source
    );

  };


  /* =========================================================
     COUNT
     ========================================================= */

  OSReviews.prototype.readCount = function (
    widget
  ) {

    var source =
      widget.getAttribute(
        'data-number-of-reviews'
      ) ||
      widget.getAttribute(
        'data-number-reviews'
      );


    var countNode =
      widget.querySelector(
        '.jdgm-rev-widg__summary-text'
      );


    if (
      !source &&
      countNode
    ) {

      source =
        countNode.textContent;

    }


    var value =
      this.parseNumber(
        source
      );


    if (value !== null) {

      return Math.round(
        value
      );

    }


    return widget.querySelectorAll(
      '.jdgm-rev'
    ).length;

  };


  /* =========================================================
     REVIEW RATING
     ========================================================= */

  OSReviews.prototype.readReviewRating = function (
    node
  ) {

    if (!node) {

      return null;

    }


    var source =
      node.getAttribute(
        'data-score'
      ) ||
      node.getAttribute(
        'aria-label'
      );


    if (source) {

      var parsed =
        this.parseNumber(
          source
        );


      if (parsed !== null) {

        return parsed;

      }

    }


    var activeStars =
      node.querySelectorAll(
        '.jdgm-star.jdgm--on'
      ).length;


    if (activeStars > 0) {

      return activeStars;

    }


    return null;

  };


  /* =========================================================
     NUMBER
     ========================================================= */

  OSReviews.prototype.parseNumber = function (
    value
  ) {

    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {

      return null;

    }


    var match =
      String(value)
        .replace(',', '.')
        .match(
          /\d+(\.\d+)?/
        );


    if (!match) {

      return null;

    }


    return Number(
      match[0]
    );

  };


  /* =========================================================
     DATE

     Eksempler:

     2026-07-08T19:29:08Z
     -> 08.07.2026

     2026-07-08
     -> 08.07.2026

     08/07/2026
     -> 08.07.2026
     ========================================================= */

  OSReviews.prototype.formatDate = function (
    value
  ) {

    if (!value) {

      return '';

    }


    var cleanValue =
      String(value)
        .replace(/\u00a0/g, ' ')
        .trim();


    /*
      ISO:
      YYYY-MM-DD...
    */

    var isoMatch =
      cleanValue.match(
        /^(\d{4})-(\d{2})-(\d{2})/
      );


    if (isoMatch) {

      return (
        isoMatch[3] +
        '.' +
        isoMatch[2] +
        '.' +
        isoMatch[1]
      );

    }


    /*
      Europeisk:
      D/M/YYYY
      DD/MM/YYYY
      D-M-YYYY
      DD.MM.YYYY
    */

    var europeanMatch =
      cleanValue.match(
        /^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})/
      );


    if (europeanMatch) {

      var day =
        europeanMatch[1].padStart(
          2,
          '0'
        );


      var month =
        europeanMatch[2].padStart(
          2,
          '0'
        );


      return (
        day +
        '.' +
        month +
        '.' +
        europeanMatch[3]
      );

    }


    /*
      Siste fallback hvis Judge.me en dag
      sender et annet gyldig datoformat.
    */

    var parsedDate =
      new Date(
        cleanValue
      );


    if (
      !Number.isNaN(
        parsedDate.getTime()
      )
    ) {

      try {

        return new Intl.DateTimeFormat(
          'nb-NO',
          {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone: 'UTC'
          }
        )
          .format(
            parsedDate
          )
          .replace(/\s/g, '');

      } catch (error) {

        return cleanValue;

      }

    }


    return cleanValue;

  };


  /* =========================================================
     REVIEWS PER PAGE
     ========================================================= */

  OSReviews.prototype.getPerPage = function () {

    return window.matchMedia(
      '(max-width: 749px)'
    ).matches
      ? 1
      : 2;

  };


  /* =========================================================
     UPDATE
     ========================================================= */

  OSReviews.prototype.update = function () {

    if (!this.pages.length) {

      return;

    }


    this.pageCount =
      this.pages.length;


    if (
      this.page >=
      this.pageCount
    ) {

      this.page =
        Math.max(
          0,
          this.pageCount - 1
        );

    }


    if (this.page < 0) {

      this.page = 0;

    }


    this.renderDots();


    var pageElement =
      this.pages[
        this.page
      ];


    this.offset =
      pageElement
        ? pageElement.offsetLeft
        : 0;


    this.track.style.transition =
      this.reduceMotion.matches
        ? 'none'
        : 'transform 320ms cubic-bezier(.22,.61,.36,1)';


    this.track.style.transform =
      'translate3d(' +
      (-this.offset) +
      'px,0,0)';


    if (this.controls) {

      this.controls.hidden =
        this.pageCount <= 1;

    }


    this.updateViewportHeight();

  };


  /* =========================================================
     HEIGHT
     ========================================================= */

  OSReviews.prototype.updateViewportHeight = function () {

    var self = this;


    if (this.heightFrame) {

      window.cancelAnimationFrame(
        this.heightFrame
      );

    }


    this.heightFrame =
      window.requestAnimationFrame(
        function () {

          self.heightFrame = null;


          var pageElement =
            self.pages[
              self.page
            ];


          if (pageElement) {

            self.viewport.style.height =
              pageElement.offsetHeight +
              'px';

          }

        }
      );

  };


  /* =========================================================
     DOTS
     ========================================================= */

  OSReviews.prototype.renderDots = function () {

    if (!this.dots) {

      return;

    }


    this.dots.replaceChildren();


    for (
      var index = 0;
      index < this.pageCount;
      index += 1
    ) {

      var dot =
        document.createElement(
          'button'
        );


      dot.type =
        'button';


      dot.className =
        'os-product-reviews__dot';


      dot.setAttribute(
        'aria-current',
        index === this.page
          ? 'true'
          : 'false'
      );


      dot.setAttribute(
        'aria-label',
        'Vis side ' +
        (index + 1) +
        ' med anmeldelser'
      );


      dot.addEventListener(
        'click',
        this.goTo.bind(
          this,
          index
        )
      );


      this.dots.appendChild(
        dot
      );

    }

  };


  /* =========================================================
     GO TO
     ========================================================= */

  OSReviews.prototype.goTo = function (
    page
  ) {

    if (
      this.pageCount <= 1
    ) {

      return;

    }


    if (page < 0) {

      this.page =
        this.pageCount - 1;

    } else if (
      page >=
      this.pageCount
    ) {

      this.page = 0;

    } else {

      this.page = page;

    }


    this.update();

  };


  /* =========================================================
     RESIZE
     ========================================================= */

  OSReviews.prototype.onResize = function () {

    var newPerPage =
      this.getPerPage();


    if (
      newPerPage !==
      this.perPage
    ) {

      this.page = 0;

      this.buildPages();

    }


    this.update();

  };


  /* =========================================================
     SWIPE
     ========================================================= */

  OSReviews.prototype.onPointerDown = function (
    event
  ) {

    if (
      event.button &&
      event.button !== 0
    ) {

      return;

    }


    this.dragging = true;

    this.hasDragged = false;

    this.startX =
      event.clientX;

    this.startY =
      event.clientY;


    if (
      this.viewport.setPointerCapture
    ) {

      try {

        this.viewport.setPointerCapture(
          event.pointerId
        );

      } catch (error) {}

    }

  };


  OSReviews.prototype.onPointerMove = function (
    event
  ) {

    if (
      !this.dragging ||
      this.pageCount <= 1
    ) {

      return;

    }


    var deltaX =
      event.clientX -
      this.startX;


    var deltaY =
      event.clientY -
      this.startY;


    if (
      Math.abs(deltaX) < 8 ||
      Math.abs(deltaX) <
      Math.abs(deltaY)
    ) {

      return;

    }


    this.hasDragged = true;


    this.track.style.transition =
      'none';


    this.track.style.transform =
      'translate3d(' +
      (
        (-this.offset) +
        deltaX
      ) +
      'px,0,0)';


    event.preventDefault();

  };


  OSReviews.prototype.onPointerUp = function (
    event
  ) {

    if (!this.dragging) {

      return;

    }


    var deltaX =
      event.clientX -
      this.startX;


    this.dragging = false;


    if (
      this.viewport.releasePointerCapture
    ) {

      try {

        this.viewport.releasePointerCapture(
          event.pointerId
        );

      } catch (error) {}

    }


    if (
      this.hasDragged &&
      Math.abs(deltaX) > 42
    ) {

      if (deltaX < 0) {

        this.goTo(
          this.page + 1
        );

      } else {

        this.goTo(
          this.page - 1
        );

      }

    } else {

      this.update();

    }

  };


  /* =========================================================
     START
     ========================================================= */

  function initialize(scope) {
    scope.querySelectorAll('[data-os-product-reviews]').forEach(function (element) {
      if (!element.osReviewsInstance) {
        element.osReviewsInstance = new OSReviews(element);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-os-product-reviews]').forEach(function (element) {
      if (element.osReviewsInstance) {
        element.osReviewsInstance.destroy();
        delete element.osReviewsInstance;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-why"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('os-why-reveal')) {
  customElements.define('os-why-reveal', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.motion !== 'true' || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motionQuery.matches) return;
      this.animations = [];
      this.stopMotion = () => {
        if (this.motionQuery.matches) {
          this.observer?.disconnect();
          this.animations.forEach(animation => animation.cancel());
        }
      };
      this.motionQuery.addEventListener('change', this.stopMotion);
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          if (this.motionQuery.matches || !entry.target.animate) return;
          this.animations.push(entry.target.animate(
            [{ opacity: 0.65, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 450, easing: 'cubic-bezier(.2,.65,.3,1)' }
          ));
        });
      }, { threshold: 0.12 });
      this.querySelectorAll('.os-why__card').forEach(card => this.observer.observe(card));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      if (this.stopMotion) this.motionQuery.removeEventListener('change', this.stopMotion);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
